import graphql from "babel-plugin-relay/macro";
import { useAtomValue } from "jotai";
import { useFragment } from "react-relay";

import { currentModalStepAtom } from "../../atoms/stores";
import { CancelBooking } from "../CancelBooking/CancelBooking";
import { TransferOwnership } from "../TransferOwnership/TransferOwnership";
import { ModalStepOutlet_CancelBooking_Booking$key } from "./__generated__/ModalStepOutlet_CancelBooking_Booking.graphql";

type Props = {
  bookingRef: ModalStepOutlet_CancelBooking_Booking$key;
  onClose: () => void;
  currentUserClientId: string;
};

export const ModalStepOutlet = ({
  bookingRef,
  onClose,
  currentUserClientId,
}: Props) => {
  const booking = useFragment(ModalStepOutletFragmentString, bookingRef);
  const currentModalStep = useAtomValue(currentModalStepAtom);

  const isCancelBookingStep = currentModalStep.type === "CancelBooking";

  return (
    <>
      {isCancelBookingStep && booking ? (
        <CancelBooking
          bookingRef={booking}
          onClose={onClose}
          currentUserClientId={currentUserClientId}
        />
      ) : (
        <TransferOwnership
          currentUserClientId={currentUserClientId}
          onClose={onClose}
        />
      )}
    </>
  );
};
const ModalStepOutletFragmentString = graphql`
  fragment ModalStepOutlet_CancelBooking_Booking on Booking {
    ...CancelBooking_Booking
  }
`;
